import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const Wrapper = styled.div.withConfig({ componentId: 'sc-1qt6bb4-0' })`
    background-color: var(--c-bg-main);
    box-shadow: ${(props) => props.theme.boxShadow.strong};
`;

export const Body = styled.div.withConfig({ componentId: 'sc-1qt6bb4-1' })`
    padding: ${size(2)};
`;

export const Details = styled.div.withConfig({ componentId: 'sc-1qt6bb4-2' })`
    padding: ${size(2)};
    border-top: 1px solid var(--c-border-main);
`;

export const Action = styled.div.withConfig({ componentId: 'sc-1qt6bb4-3' })`
    position: relative;
    display: flex;
    justify-content: center;
    padding: ${size(2)};
    border-top: 1px solid var(--c-border-main);
`;
